import { type InferOutput, minLength, object, pipe, string } from 'valibot'

import { VALIDATION_MESSAGES } from '@/constants/common/validation.constants'

export const createTruckModelFormValueSchema = object({
  /** 車種名称 */
  name: pipe(
    string(),
    minLength(1, VALIDATION_MESSAGES.TRUCK_MODEL_NAME_REQUIRED)
  ),
  /** 車種コード */
  code: pipe(
    string(),
    minLength(1, VALIDATION_MESSAGES.TRUCK_MODEL_CODE_REQUIRED)
  )
})

export type CreateTruckModelFormValue = InferOutput<
  typeof createTruckModelFormValueSchema
>

export const createDefaultTruckModelFormValue = {
  name: '',
  code: ''
}
